<template>
    <div class="container-navbar">
        <div class="navbar-logo" @click="go('mp')">
            <img src="@/assets/login/logo-white.png" />
        </div>
        <div class="navbox">
            <div :class="active == 'activity' ? 'nav active' : 'nav'" @click="go('mp/activity')">
                <div class="navtext">
                    我的<br />活动
                </div>
                <div class="line"></div>
            </div>
            <div :class="active == 'coffee' ? 'nav active' : 'nav'" @click="go('mp/coffee')">
                <div class="navtext">
                    我的<br />咖啡豆
                </div>
                <div class="line"></div>
            </div>
            <div :class="active == 'feedback' ? 'nav active' : 'nav'" @click="go('mp/feedback')">
                <div class="navtext">
                    用户<br />反馈
                </div>
                <div class="line"></div>
            </div>
            <div :class="active == 'words' ? 'nav active' : 'nav'" @click="go('mp/words')">
                <div class="navtext">
                    快捷<br />词库
                </div>
                <div class="line"></div>
            </div>
            <div :class="active == 'staff' ? 'nav active' : 'nav'" @click="go('mp/staff')">
                <div class="navtext">
                    员工<br />管理
                </div>
                <div class="line"></div>
            </div>
        </div>
        <div class="navbar-person">
            <div class="logout" @click="logout()">
                退出
            </div>
            <!-- <div class="navbar-avatar"></div> -->
        </div>
    </div>
</template>

<script>
// import { apiName } from '../../request/api'

export default {
    components: {

    },
    name: 'Index',
    props: {
        active: String
    },
    data() {
        return {
            loading: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() { },
        api() {
            let self = this
            apiName({
                page: 1,
                size: 10,
            }).then(res => {
                console.log(res.data)
            }).catch(err => {
                console.log(err)
            })
        },
        logout() {
            localStorage.removeItem('token')
            this.go('')
        },
        go(where) {
            this.$router.push('/' + where)
        },
    }
}
</script>

<style scoped>
.container-navbar {
    width: 60px;
    height: 94%;
    position: fixed;
    left: 20px;
    top: 3%;
    border-radius: 10px;
    background-color: #489D80;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    /* transform: translateX(-100px); */
    /* animation: navbar-anime 0.8s ease forwards; */
    z-index: 10;
}

@keyframes navbar-anime {
    0% {
        transform: translateX(-100px)
    }

    50% {
        transform: translateX(10px)
    }

    100% {
        transform: translateX(0)
    }
}

.navbar-logo {
    width: 60px;
    height: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: #449479; */
    cursor: pointer;
}

.navbar-logo:hover {
    background-color: #449479;
    transition: all 0.3s ease;

}

.navbar-logo img {
    display: block;
    width: 40px;
}

.navbox {
    flex: 1;
    height: 1px;
}

.navbox .nav {
    color: #fff;
    cursor: pointer;
    width: 60px;
    height: 60px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.5;
    z-index: 2;
}

.navtext {
    flex: 1;
    height: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

}

.navbox .line {

    width: 15px;
    height: 2px;
    background-color: #449479;
    position: relative;

    top: -2px;

}

.navbox .nav:hover {
    background-color: #449479;
    transition: all 0.3s ease;

}

.navbox .nav.active .navtext {
    font-weight: bold;
}

.navbox .nav.active .line {
    background-color: #fff
}

.navbar-person {
    width: 60px;
    min-height: 50px;
    border: 1px solid #449479;
}

.logout {
    cursor: pointer;
    color: #fff;
    width: 60px;
    height: 50px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.5;
    z-index: 2;
}

.logout:hover {
    background-color: #449479;
    transition: all 0.3s ease;
}

.navbar-avatar {
    width: 60px;
    height: 60px;
}
</style>